/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ComputeHardware = {
  accelerator: string;
  gpuCount: number;
  gpuMemoryGb: number;
  interconnect?: string | undefined;
};

/** @internal */
export const ComputeHardware$inboundSchema: z.ZodType<
  ComputeHardware,
  z.ZodTypeDef,
  unknown
> = z.object({
  accelerator: z.string(),
  gpu_count: z.number().int(),
  gpu_memory_gb: z.number().int(),
  interconnect: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "gpu_count": "gpuCount",
    "gpu_memory_gb": "gpuMemoryGb",
  });
});
/** @internal */
export type ComputeHardware$Outbound = {
  accelerator: string;
  gpu_count: number;
  gpu_memory_gb: number;
  interconnect?: string | undefined;
};

/** @internal */
export const ComputeHardware$outboundSchema: z.ZodType<
  ComputeHardware$Outbound,
  z.ZodTypeDef,
  ComputeHardware
> = z.object({
  accelerator: z.string(),
  gpuCount: z.number().int(),
  gpuMemoryGb: z.number().int(),
  interconnect: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    gpuCount: "gpu_count",
    gpuMemoryGb: "gpu_memory_gb",
  });
});

export function computeHardwareToJSON(
  computeHardware: ComputeHardware,
): string {
  return JSON.stringify(ComputeHardware$outboundSchema.parse(computeHardware));
}
export function computeHardwareFromJSON(
  jsonString: string,
): SafeParseResult<ComputeHardware, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ComputeHardware$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ComputeHardware' from JSON`,
  );
}
